'use client';

const performSilentLogin = () => {
    const currentUrl = window.location.pathname;
    const silentLoginPath = `/silent-login?returnUrl=${encodeURIComponent(currentUrl)}`;
    window.location.href = silentLoginPath;
};

export default performSilentLogin;
